import React from 'react';
import { Box } from '@mui/material';
import noDataImage from '@src/assets/images/no-data.svg';
import { StyledNoData } from './index.style';

const NoData = ({ children, dropTable, height, noDataText, image }) => (
  <Box width="100%" margin="auto">
    <StyledNoData height={height}>
      {children || (
        <img
          style={{ height: dropTable ? '86px' : 'auto' }}
          src={image || noDataImage}
          alt="no data"
        />
      )}
      {noDataText && <div className="no-data-text">{noDataText}</div>}
    </StyledNoData>
  </Box>
);

export default NoData;
